import { render, staticRenderFns } from "./ViewOnboardingVendor.vue?vue&type=template&id=34813b58&scoped=true&"
import script from "./ViewOnboardingVendor.vue?vue&type=script&lang=ts&"
export * from "./ViewOnboardingVendor.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOnboardingVendor.vue?vue&type=style&index=0&id=34813b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34813b58",
  null
  
)

export default component.exports